<div class="admin-dashboard">

  <!-- HEADER -->
  <div class="dashboard-header">

    <div class="header-text">
      <h1>Admin Dashboard</h1>
      <p>
        Verwalten Sie Benutzerkonten, Rollen und Einmalpasswörter auf einen Blick.
      </p>
    </div>

    <!-- HEADER BUTTONS -->
    <div class="header-actions">

      <button
        mat-raised-button
        color="primary"
        type="button"
        (click)="openCreateUserDialog()">

        <mat-icon>person_add</mat-icon>
        <span>Benutzer hinzufügen</span>

      </button>

    </div>

  </div>


  <!-- STATS -->
  <div class="stats-grid">

    <mat-card class="stat-card">

      <mat-icon color="primary">
        group
      </mat-icon>

      <div class="stat-details">

        <span class="stat-label">
          Gesamtbenutzer
        </span>

        <span class="stat-value">
          {{ totalUsers }}
        </span>

      </div>

    </mat-card>


    <mat-card class="stat-card">

      <mat-icon color="primary">
        security
      </mat-icon>

      <div class="stat-details">

        <span class="stat-label">
          Admins
        </span>

        <span class="stat-value">
          {{ totalAdmins }}
        </span>

      </div>

    </mat-card>


    <mat-card class="stat-card">

      <mat-icon color="primary">
        badge
      </mat-icon>

      <div class="stat-details">

        <span class="stat-label">
          Standardnutzer
        </span>

        <span class="stat-value">
          {{ totalStandardUsers }}
        </span>

      </div>

    </mat-card>

  </div>


  <!-- VERWALTUNGS-KACHELN -->
  <div class="action-grid">

    <mat-card
      class="action-card"
      tabindex="0"
      role="button"
      (click)="openKategorieAdmin()"
      (keydown.enter)="openKategorieAdmin()"
      (keydown.space)="openKategorieAdmin()">

      <mat-icon color="primary">
        category
      </mat-icon>

      <div class="action-details">

        <span class="action-label">
          Kategorien verwalten
        </span>

        <span class="action-hint">
          Kategorien, Abschnitte und Prüfpunkte pflegen
        </span>

      </div>

      <mat-icon class="action-arrow">
        chevron_right
      </mat-icon>

    </mat-card>


    <mat-card
      class="action-card"
      tabindex="0"
      role="button"
      (click)="openQrCodeAdmin()"
      (keydown.enter)="openQrCodeAdmin()"
      (keydown.space)="openQrCodeAdmin()">

      <mat-icon color="primary">
        qr_code_2
      </mat-icon>

      <div class="action-details">

        <span class="action-label">
          QR-Codes erstellen
        </span>

        <span class="action-hint">
          Etiketten für Messstellen generieren und drucken
        </span>

      </div>

      <mat-icon class="action-arrow">
        open_in_new
      </mat-icon>

    </mat-card>

  </div>


  <!-- BENUTZERVERWALTUNG -->
  <mat-card class="table-card">

    <mat-card-header>

      <mat-card-title>
        Benutzerverwaltung
      </mat-card-title>

      <mat-card-subtitle>
        Suche, bearbeiten oder sende neue Einmalpasswörter.
      </mat-card-subtitle>

    </mat-card-header>


    <mat-card-content>

      <!-- SUCHE -->
      <div class="table-toolbar">

        <mat-form-field
          appearance="outline"
          class="search-field">

          <mat-label>
            Suche
          </mat-label>

          <input
            matInput
            [value]="filterValue"
            (input)="applyFilter($any($event.target).value)"
            placeholder="Name oder E-Mail"
          />

          <span
            matSuffix
            class="suffix-icons">

            <button
              *ngIf="filterValue"
              mat-icon-button
              type="button"
              aria-label="Filter löschen"
              (click)="clearFilter()">

              <mat-icon>
                close
              </mat-icon>

            </button>

            <mat-icon>
              search
            </mat-icon>

          </span>

        </mat-form-field>

      </div>


      <!-- LOADING -->
      <div
        *ngIf="isLoading"
        class="loading-state">

        <mat-progress-spinner
          diameter="48"
          strokeWidth="4"
          mode="indeterminate">
        </mat-progress-spinner>

      </div>


      <!-- INHALT -->
      <ng-container *ngIf="!isLoading">

        <!-- KEINE BENUTZER -->
        <div
          *ngIf="dataSource.data.length === 0"
          class="empty-state">

          <mat-icon>
            group_off
          </mat-icon>

          <p>
            Keine Benutzer vorhanden.
          </p>

        </div>


        <!-- TABELLE -->
        <div
          class="table-wrapper"
          *ngIf="dataSource.data.length > 0">

          <table
            mat-table
            [dataSource]="dataSource"
            matSort
            class="mat-elevation-z8">


            <!-- BENUTZERNAME -->
            <ng-container matColumnDef="userName">

              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header>

                Benutzername

              </th>

              <td
                mat-cell
                *matCellDef="let user">

                {{ user.username }}

              </td>

            </ng-container>


            <!-- EMAIL -->
            <ng-container matColumnDef="email">

              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header>

                E-Mail

              </th>

              <td
                mat-cell
                *matCellDef="let user">

                {{ user.email }}

              </td>

            </ng-container>


            <!-- ROLLE -->
            <ng-container matColumnDef="rolle">

              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header>

                Rolle

              </th>

              <td
                mat-cell
                *matCellDef="let user">

                {{ user.roles }}

              </td>

            </ng-container>


            <!-- AKTIONEN -->
            <ng-container matColumnDef="actions">

              <th
                mat-header-cell
                *matHeaderCellDef>

                Aktionen

              </th>

              <td
                mat-cell
                *matCellDef="let user"
                class="action-buttons">


                <!-- BEARBEITEN -->
                <button
                  mat-icon-button
                  color="primary"
                  matTooltip="Benutzer bearbeiten"
                  (click)="openEditUserDialog(user)">

                  <mat-icon>
                    edit
                  </mat-icon>

                </button>


                <!-- PASSWORT -->
                <button
                  mat-icon-button
                  color="accent"
                  matTooltip="Einmalpasswort senden"
                  (click)="openResetPasswordDialog(user)"
                  [disabled]="resetInProgress[user.id || '']">

                  <ng-container
                    *ngIf="!resetInProgress[user.id || '']">

                    <mat-icon>
                      key
                    </mat-icon>

                  </ng-container>

                  <mat-progress-spinner
                    *ngIf="resetInProgress[user.id || '']"
                    diameter="20"
                    strokeWidth="3"
                    mode="indeterminate">
                  </mat-progress-spinner>

                </button>


                <!-- LÖSCHEN -->
                <button
                  mat-icon-button
                  color="warn"
                  matTooltip="Benutzer löschen"
                  (click)="deleteUser(user.id || '')">

                  <mat-icon>
                    delete
                  </mat-icon>

                </button>

              </td>

            </ng-container>


            <tr
              mat-header-row
              *matHeaderRowDef="displayedColumns">
            </tr>

            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumns;">
            </tr>

          </table>

        </div>

      </ng-container>

    </mat-card-content>

  </mat-card>

</div>